import React from 'react'
import { useConfig } from 'msp-integrations'
import { useIntl } from 'react-intl'

export type PriceTagProps = {
  className?: string
  price: number
  currency: string
  c_basePrice?: string
  showTaxesInfo?: boolean
  smallDiscountPrice?: boolean
  discountPrice?: number
  isPDP?: boolean
  alignBasePriceRight?: boolean
  showLowestPrice?: boolean
  lastMonthPrice?: number | false
  lastMonthPriceCallback?: string | false
}

const PriceTag = ({
  className,
  discountPrice,
  c_basePrice,
  price,
  currency,
  showTaxesInfo = false,
  smallDiscountPrice = false,
  isPDP = false,
  alignBasePriceRight = false,
  lastMonthPrice = false,
  lastMonthPriceCallback = false,
  showLowestPrice = false
}: PriceTagProps) => {
  const { formatMessage, formatNumber } = useIntl()
  const {
    theme: { font }
  } = useConfig()

  const formatPrice = (price?: number) =>
    (price || price === 0.0) && currency
      ? formatNumber(price, {
          style: 'currency',
          currency: currency,
          currencyDisplay: 'code'
        })
      : ''
  const priceFormatted = formatPrice(price)
  const discountPriceFormatted =
    discountPrice !== price && formatPrice(discountPrice)

  return (
    <div className={className}>
      <div className='min-w-[75px]'>
        <p
          className={
            !discountPriceFormatted
              ? `${font.medium} ${isPDP ? 'text-20 leading-7' : 'text-16'}`
              : `${font.regular} text-grayRegular text-12 ${
                  !smallDiscountPrice ? 'lg:text-16' : ''
                } leading-[0.8em] line-through`
          }
        >{`${priceFormatted}${
          priceFormatted && !discountPriceFormatted && !showTaxesInfo ? '*' : ''
        }`}</p>
        <div className={`${alignBasePriceRight ? 'flex items-center' : ''}`}>
          {discountPriceFormatted && (
            <p
              className={`${font.medium} min-w-[75px] ${
                isPDP ? 'text-20' : 'text-16'
              }`}
            >{`${discountPriceFormatted}${!showTaxesInfo ? '*' : ''}`}</p>
          )}
          {c_basePrice && alignBasePriceRight && discountPriceFormatted && (
            <p
              className={`${font.regular} text-grayRegular text-12 ml-4 leading-[0.8em]`}
            >
              {c_basePrice}
            </p>
          )}
        </div>
        {showTaxesInfo && (
          <p
            className={`${font.regular} text-grayRegular text-12 leading-12 tracking-0.4`}
          >
            {formatMessage({
              id: 'msp.cart.price.tag.taxes',
              defaultMessage: 'incl. VAT'
            })}
          </p>
        )}
        {showLowestPrice && lastMonthPrice && (
          <p className={`${font.regular} text-grayRegular text-12 mt-2`}>
            {`${
              lastMonthPriceCallback ||
              formatMessage({
                id: 'msp.cart.price.tag.last_month_lowest_price.fallback_message',
                defaultMessage: 'Last month lowest price:'
              })
            } ${formatPrice(lastMonthPrice)}`}
          </p>
        )}
      </div>
      {(!discountPriceFormatted || !alignBasePriceRight) && c_basePrice && (
        <p
          className={`${font.regular} text-grayRegular text-12 leading-[0.8em]`}
        >
          {c_basePrice}
        </p>
      )}
    </div>
  )
}

export default PriceTag
